// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__V06q5","loader":"Spinner_loader__lI_2U","spin":"Spinner_spin__Dfcyj","scaling":"Spinner_scaling__MpXVO"};